import uk from "./uk.js";
/** @deprecated Use `uk` instead. */
export default function () {
    return uk();
}
